(function() {
	'use strict';

	angular.module('quantixApp').controller('PeerSuggestionController',
			PeerSuggestionController);

	PeerSuggestionController.$inject = [ '$scope', '$window', '$stateParams',
			'CompanyProfileService', '$timeout', '$rootScope', 'AlertService',
			'$uibModalInstance', 'GenericService', 'PortfolioService',
			'ivhTreeviewBfs', 'ivhTreeviewOptions', 'ivhTreeviewMgr', '$http' ];

	function PeerSuggestionController($scope, $window, $stateParams,
			CompanyProfileService, $timeout, $rootScope, AlertService,
			$uibModalInstance, GenericService, PortfolioService,
			ivhTreeviewBfs, ivhTreeviewOptions, ivhTreeviewMgr, $http) {
		var vm = this;
		$scope.peerSuggestionGrid = '';
		$scope.clear = function() {
			$uibModalInstance.dismiss('cancel');
		}
		$scope.industryType = {'value' : 'sameIndustry'};
		$scope.selectedComp = [];
		$scope.selectedIndComp = [];
		var idss = new Array();
		$scope.ratingScaleData = [];		
		$scope.industryCategory = 'GICS';
		$scope.ratingScaleLong = [];
		
		
		$scope.minRatingAmount = '';
		$scope.maxRatingAmount = '';
		$scope.categoryList = [{'categoryId' : 'GICS','categoryName' : 'GICS'},{'categoryId' : 'AMFI','categoryName' : 'AMFI'},{'categoryId' : 'BSE','categoryName' : 'BSE'},{'categoryId' : 'IRS','categoryName' : 'IRS'},{'categoryId' : 'RBI','categoryName' : 'RBI'}];
		
		$rootScope.$on("peerCompUibModalClose", function() {
			$scope.clear();
		});

		$scope.setTabSetData = function(tabsetId) {
			$scope.currentbstId = tabsetId;
		}

		
		
		// Start to get location and industry tree

		/* Industry part */
		// for industry tree
		var opts = ivhTreeviewOptions(), isExpanded = opts.expandedAttribute;
		$scope.viewTreeIndustry = false;
		var indgri = null;
		var arrayind = new Array();
		var allKeysInd = [];
		var allKeysLocations = [];
		var filterselectall = false;
		// for industry tree

		$scope.onGridCreationCompletedIndustry = function(event) {

			if (event != null) {
				indgri = event.target;
				indgri.enableHeightAutoAdjust = true;
				indgri.validateNow();

			} else {
				indgri.enableHeightAutoAdjust = true;
				indgri.clearFilter();
				indgri.expandAll();
				indgri.setFilterValue('label', firstcharind, indgri);
				indgri.validateNow();
			}
		};
		$scope.selectedIndustries = [];
		$scope.selectAllind = function(flag) {
			allKeysInd = [];
			if (flag) {
				$scope.noinddata = false;
				arrayind = [];
				$scope.selectedIndustries = [];
				if (indfiltervaluchanged) {
					filterselectall = true;
					$scope.industryall = false;
				} else {
					filterselectall = false;
					$scope.industryall = true;
				}

				ivhTreeviewBfs($scope.sampleIndustrydata, opts, function(node) {

					if (indfiltervaluchanged) {

						if (node.label.toLowerCase().includes(firstcharind)) {
							$scope.selectedIndustries.push(node.id);
							allKeysInd.push(node.id);
							if (node.children.length > 0) {
								ivhTreeviewBfs(node, opts, function(childnode) {
									allKeysInd.push(childnode.id);
								});
							}

						}

					} else {
						allKeysInd.push(node.id);
					}

				});

				$scope.badgeStringInd = $scope.selectedIndustries.toString();

				$timeout(function() {
					indgri.setSelectedKeys(allKeysInd, false);
				}, 100);
			} else {
				arrayind = [];
				$scope.selectedIndustries = [];
				$scope.industryall = false;
				if (indgri != null) {
					indgri.clearSelection();
					indgri.clearAllFilters();
					indgri.clearChanges();
					indfiltervaluchanged = false;
					indgri.collapseAll();
					indgri.validateNow();
				}

				idss = [];
				$scope.idStack = [];
				// indgri.rebuild();
				// alert($scope.selectedProducts);
			}
		}

		$scope.ind = {
			indstatus : false
		};
		$scope.ind.indstatus = false;
		var cnt = 0;

		$scope.setIndustryTree = function() {

			$scope.ind.indstatus = true;
			// $scope.showResult = false;

			$scope.gridOptionsSec = {
				dataProvider : $scope.sampleIndustrydata,
				delegate : $scope
			};

			if (cnt == 0) {
				cnt = 1;
				$timeout(function() {
					var l = document.getElementById('industryButton');
					l.click();
				}, 100, false);

			}

			// $scope.selectAllind(true);
		}

		$scope.getChildIndustry = function(childArray) {

			if (childArray.children.length <= 0) {
				$scope.idStack.push(childArray.id);
				return childArray.id;
			} else {
				for (var i = 0; i < childArray.children.length; i++) {
					var childArr = childArray.children[i];
					// return $scope.getChildIndustry(childArr);
					$scope.getChildIndustry(childArr);
				}
			}

		}

		$scope.spliceChildIndustry = function(childArray) {
			var subchild = childArray.children[0];
			if (($scope.idStack.indexOf(childArray.id) != -1)
					&& (childArray.children.length <= 0
							|| angular.isUndefined(subchild.id) || subchild.id == childArray.id)) {
				$scope.idStack.splice($scope.idStack.indexOf(childArray.id), 1);
			} else {
				for (var i = 0; i < childArray.children.length; i++) {
					var childArr = childArray.children[i];
					$scope.spliceChildIndustry(childArr);
				}
			}

		}

		$scope.spliceChildIndustryFromarrayind = function(childArray) {
			var subchild = childArray.children[0];

			if (arrayind.indexOf(childArray.label) != -1) {
				arrayind.splice(arrayind.indexOf(childArray.label), 1);
			}

			for (var i = 0; i < childArray.children.length; i++) {
				var childArr = childArray.children[i];
				$scope.spliceChildIndustryFromarrayind(childArr);
			}

		}

		$scope.idStack = [];
		idss = new Array();
		$scope.setbadgesforIndustry = function(evt) {
			var grid = evt.target;
			if (evt.isItemSelected) {
				$scope.noinddata = false;

				if (evt.item.children.length > 0) {
					// to remove already selected child
					for (var i = 0; i < evt.item.children.length; i++) {
						var childArr = evt.item.children[i];
						$scope.spliceChildIndustry(childArr);
						$scope.spliceChildIndustryFromarrayind(childArr);
					}
					// ended
					for (var i = 0; i < evt.item.children.length; i++) {
						var childArr = evt.item.children[i];
						var id = $scope.getChildIndustry(childArr);
						idss.push(id);
					}
				} else {
					idss.push(evt.item.id);
					$scope.idStack.push(evt.item.id)
				}
				arrayind.push(evt.item.label);
			} else {

				if (evt.item.children.length == 0) {
					if (idss.indexOf(evt.item.id) != -1) {
						idss.splice(idss.indexOf(evt.item.id), 1);
					}
					if ($scope.idStack.indexOf(evt.item.id) != -1) {
						$scope.idStack.splice($scope.idStack
								.indexOf(evt.item.id), 1);
					}
				} else {
					idss.splice(idss.indexOf(evt.item.id),
							evt.item.children.length);
					for (var i = 0; i < evt.item.children.length; i++) {
						var childArr = evt.item.children[i];
						$scope.spliceChildIndustry(childArr);
					}

				}

				if (arrayind.indexOf(evt.item.label) != -1) {
					arrayind.splice(arrayind.indexOf(evt.item.label), 1);
				} else if ($scope.industryall) {
					$scope.industryall = false;
					arrayind = [];
					arrayind.push("Multiple Industries selected");
				}

				else if (indgri.getSelectedObjects().length > 1) {
					arrayind = [];
					arrayind.push("Multiple Industries selected");
				} else {
					arrayind = [];
				}
			}
			$timeout(
					function() {
						$scope.selectedIndustries = angular.copy(arrayind);
						$scope.badgeStringInd = $scope.selectedIndustries
								.toString();

						if ($scope.badgeStringInd.length > 30) {
							for (var i = 0; i < $scope.selectedIndustries.length; i++) {
								if ($scope.selectedIndustries[i].length > 10) {
									$scope.selectedIndustries[i] = $scope.selectedIndustries[i]
											.substr(0, 14)
											+ '..';
								}
							}
							$scope.badgeStringInd = $scope.selectedIndustries
									.toString();
						} else {
							$scope.badgeStringInd = $scope.selectedIndustries
									.toString();
						}
					}, 100);
		}

		var indfiltervaluchanged = false;
		var locfiltervaluchanged = false;
		var firstcharind = '';

		$scope.filerPageSortHandle = function(event) {
			setTimeout(
					function() {
						var filter = event.target.getRootFilter();
						var grid = event.target;
						if (!filter.filterExpressions.length) {
							grid.collapseAll();
							grid.validateNow();
							// grid.rebuild();
							indfiltervaluchanged = false;

						}
						if (!indfiltervaluchanged) {
							if (event.cause == "filterChange") {
								if (filter.filterExpressions
										&& filter.filterExpressions.length) {
									firstcharind = filter.filterExpressions[0].expression
									indfiltervaluchanged = true;
									$scope
											.onGridCreationCompletedIndustry(null);
								}
							}
						}
					}, 1);
		};

		$scope.onDynamicLevelCind = function(event) {
			// alert("dynamic");
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};

		$scope.disablecellind = function(cell) {
			return (cell.getLevel().getNestDepth() != 5);
		}// fn end

		$scope.gettooltipforIndustry = function(item, column) {
			var html = "<label title='" + item.label + "'>" + item.label
					+ "</label>"
			return html;
		};// fn end

		// getting Industry data
		$scope.gridIndustryTree = function() {

			$http.post('api/masterData/get4thLevelIndustryTreeData').success(
					function(data) {
						$scope.sampleIndustrydata = data;
						$scope.indTreeData = $scope.sampleIndustrydata;
						$scope.temp = $scope.indTreeData;
					}).error(function(data) {

			});

		}// end of industry

		// Location filter
		var locgri = null;
		var arrayloc = new Array();

		$scope.selectAllloc = function(flag) {
			allKeysLocations = [];
			if (flag) {
				arrayloc = []
				$scope.selectedLocations = [];
				if (locfiltervaluchanged) {
					$scope.selectAllflagloc = false;
				} else {
					$scope.selectAllflagloc = true;
				}

				ivhTreeviewBfs($scope.sampletreedata, opts, function(node) {
					// allKeysLocations.push(node.id);
					if (locfiltervaluchanged) {

						if (node.label.toLowerCase().includes(firstcharloc)) {
							$scope.selectedLocations.push(node.label);
							allKeysLocations.push(node.id);

							if (node.children) {
								ivhTreeviewBfs(node, opts, function(childnode) {
									allKeysLocations.push(childnode.id);
								});
							}

						}

					} else {
						allKeysLocations.push(node.id);
					}
				});

				$timeout(function() {
					locgri.setSelectedKeys(allKeysLocations, false);
				}, 100);

			} else {
				arrayloc = [];
				$scope.selectedLocations = [];
				$scope.selectAllflagloc = false;
				if (locgri != null) {
					locgri.clearSelection();
					locgri.clearAllFilters();
					locgri.collapseAll();
					locfiltervaluchanged = false;
				}
			}
		}

		$scope.locbuttonid = 'locationButton_' + $scope.name;
		$scope.indgrididtohide = "gridIndTreeData2" + $scope.name;
		$scope.locgrididtohide = "gridlocTreeData1" + $scope.name;
		$scope.loccnt = 0;
		$scope.setLocationTree = function() {

			$('#gridIndTreeData2' + $scope.name).hide();
			// $scope.loc.locstatus = true;
			$scope.showResult = false;

			$scope.gridOptionsSecLoc = {
				dataProvider : $scope.sampletreedata,
				delegate : $scope
			};

			if ($scope.loccnt == 0) {
				$scope.loccnt = 1;
				$timeout(function() {
					var l = document.getElementById('locationButton_'
							+ $scope.name);
					l.click();
				}, 100, false);
			}
			// $scope.selectAllloc(false);
		}

		$scope.setbadgesforLocation = function(evt) {

			var grid = evt.target;
			if (evt.isItemSelected) {
				arrayloc.push(evt.item.label);

			} else {
				arrayloc.splice(arrayloc.indexOf(evt.item.label), 1);
			}

			$timeout(
					function() {

						$scope.selectedLocations = angular.copy(arrayloc);
						$scope.badgeStringLoc = $scope.selectedLocations
								.toString();

						if ($scope.badgeStringLoc.length > 30) {
							for (var i = 0; i < $scope.selectedLocations.length; i++) {
								if ($scope.selectedLocations[i].length > 10) {
									$scope.selectedLocations[i] = $scope.selectedLocations[i]
											.substr(0, 14)
											+ '..';
								}
							}
							$scope.badgeStringLoc = $scope.selectedLocations
									.toString();
						} else {
							$scope.badgeStringLoc = $scope.selectedLocations
									.toString();
						}

					}, 100);

		}

		$scope.onGridCreationCompletedLocation = function(event) {

			if (event != null) {
				locgri = event.target;
				locgri.enableHeightAutoAdjust = true;
				locgri.validateNow();
			} else {
				locgri.enableHeightAutoAdjust = true;
				locgri.clearFilter();
				locgri.expandAll();
				locgri.setFilterValue('label', firstcharloc, indgri);
				locgri.validateNow();
			}
		};
		var firstcharloc = '';
		$scope.filerPageSortHandleloc = function(event) {
			setTimeout(
					function() {
						var filter = event.target.getRootFilter();
						var grid = event.target;
						if (!filter.filterExpressions.length) {
							grid.collapseAll();
							grid.validateNow();
							// grid.rebuild();
							locfiltervaluchanged = false;

						}
						if (!locfiltervaluchanged) {
							if (event.cause == "filterChange") {
								if (filter.filterExpressions
										&& filter.filterExpressions.length) {
									firstcharloc = filter.filterExpressions[0].expression
									locfiltervaluchanged = true;
									$scope
											.onGridCreationCompletedLocation(null);
								}
							}
						}
					}, 1);
		};

		function getLocationTree() {
			var promise = GenericService.getZonalLocationDetailsdata();
			promise.then(function(data) {
				$scope.sampletreedata = data;

				$scope.gridOptionsSecLoc = {
					dataProvider : $scope.sampletreedata,
					delegate : $scope
				};

			}, function(response, status, headers, config) {
				ErrorHandlerService.handleError(response, status, headers,
						config);
			});
		}
		
		$scope.getIndustryListBasedSelection = function(type){
			$scope.industryCategory = type;
			if(type == 'GICS'){
				$scope.gridIndustryTree();
			}else{
				getAlternateTreeData();
			}
		}
		
		//to get alternate industry
		function getAlternateTreeData() {
			var promise = GenericService.getAlternateTreeData($scope.industryCategory);
			promise.then(function(data) {
				$scope.sampleIndustrydata = data;
				$scope.indTreeData = $scope.sampleIndustrydata;
				$scope.temp = $scope.indTreeData;

			}, function(response, status, headers, config) {
				ErrorHandlerService.handleError(response, status, headers,
						config);
			});
		}

		getLocationTree();

		$scope.getselectedKeysForLocation = function() {
			var peerGroupLocationGridKeys = null
			var locationids = [];
			if (locgri != null && locgri != "") {
				peerGroupLocationGridKeys = locgri.getSelectedObjects();
				ivhTreeviewBfs(peerGroupLocationGridKeys, opts, function(node) {
					if (!node.children) {
						if (locationids.indexOf(node.id) == -1) {
							locationids.push(node.id);
						}
					}
				});

			}
			return locationids.toString();

		}

		// end to get location and industry tree

		$scope.getRatingScales = function() {
			$scope.mergeArray = [];
			if ($scope.ratingScaleData.length == 0) {
				PortfolioService.getRatingScaleMasterList().then(
						function(data) {
							$scope.ratingScaletype = data;

							angular.forEach(data, function(value, key) {

								if (key === 'LongTerm') {
									$scope.ratingScaleLong = value;
									$scope.issuerTermLongRating = value;

								} else if (key === 'ShortTerm') {
									$scope.ratingScaleShort = value;
									$scope.issuerRatingTermsRating = value;

									// $scope.mergeArray.concat(value);

								}
								/*
								 * $scope.mergeArray = $scope.ratingScaleLong
								 * .concat($scope.ratingScaleShort);
								 */
							});

						}, function(error) {

						});
			}
		}
		$scope.markAll = {
			checked : false
		};
		$scope.markAll1 = {
			checked : false
		};
		$scope.changeRatingType = function(markAll, markAll1, type) {
			if (type == 'shortTerm') {

				if (markAll) {
					angular.forEach($scope.ratingScaleShort,
							function(val, key) {
								val.chekced = true;
							});
				} else {
					angular.forEach($scope.ratingScaleShort,
							function(val, key) {
								val.chekced = false;
							});
				}

			} else if (type == 'longTerm') {

				if (markAll1) {
					angular.forEach($scope.ratingScaleLong, function(val, key) {
						val.chekced = true;
					});
				} else {
					angular.forEach($scope.ratingScaleLong, function(val, key) {
						val.chekced = false;
					});
				}
			}

		}

		$scope.getCompanyList = function() {
			if ($rootScope.allCompanies == undefined
					&& $stateParams.allCompanies.length > 0) {
				$scope.allCompanies = $stateParams.allCompanies;
			} else if ($rootScope.allCompanies != undefined
					&& $rootScope.allCompanies.length > 0) {
				$scope.allCompanies = $rootScope.allCompanies;
			}
			
			// for industry
			$scope.selectedIndustriesTemp = [];
			if ($scope.idStack.length == 0) {
				$scope.selectedIndustriesTemp = '';
			} else {
				$scope.selectedIndustriesTemp = $scope.idStack.map(function(
						element) {
					
					return String(element)
				})
			}
			
			if ($scope.ratingScaleLong != undefined) {
				$scope.selectedLongTerm = [];
				for ( var i in $scope.ratingScaleLong) {
					if ($scope.ratingScaleLong[i].chekced == true) {
						$scope.selectedLongTerm.push($scope.ratingScaleLong[i]);
					}
				}

				$scope.selectedLongTermTemp = $scope.selectedLongTerm
						.map(function(element) {
							return String(element.name) 
						})
			}
			
			$scope.locations = $scope.getselectedKeysForLocation();
			if($scope.minRatingAmount == undefined){
				$scope.minRatingAmount = '';
			}
			if($scope.maxRatingAmount == undefined){
				$scope.maxRatingAmount = '';
			}
			var creditData = "{'revenueFrom' : '" + $scope.minRatingAmount
				+ "','revenueTo' : '" + $scope.maxRatingAmount			
				+ "', 'ratings' : '" + $scope.selectedLongTermTemp
				+ "', 'locationids' : '" + $scope.locations
				+ "', 'industryIds' : '" + $scope.selectedIndustriesTemp
				+ "', 'industryType' : '" + $scope.industryType.value
				+ "', 'companyName' : '" + $scope.companySelectedCode
				+ "', 'industryCategory' : '" + $scope.industryCategory
				+"'}";
		creditData = creditData.replace(/\'/g, "\"");
		creditData = creditData.replace(/\</g, "\'");
			
		
			CompanyProfileService
					.getPeerSuggesionsList(creditData)
					.then(
							function(data) {
								$scope.peerData = data;								
								$scope.peersGridData = {
									dataProvider : $scope.peerData,
									delegate : $scope
								};

								angular.forEach($scope.peerData, function(
										peerData) {

									var index = $scope.allCompanies
											.indexOf(peerData.companyName);
									if (index > -1) {
										$scope.selectedComp
												.push(peerData.companyName);
										$scope.selectedIndComp
												.push(peerData.companyName);
									}

								});

								angular
										.forEach(
												$scope.allCompanies,
												function(compNameParent) {

													var compName = $scope
															.isCompanyNameExists(compNameParent);

													if ((compName == "" && compNameParent != $scope.companySelected)
															|| (compName == ""
																	&& compNameParent != $scope.companySelected && $scope.selectedComp.length == 0)) {
														$scope.selectedComp
																.push(compNameParent);
													}

												});

								$timeout(
										function() {

											$scope.peerSuggestionGrid
													.setSelectedKeys(
															$scope.selectedComp,
															false);
											$timeout(
													function() {
														if ($scope.selectedComp.length >= 3
																|| $scope.selectedComp.length == 0) {
															$scope.peerCompLength = 3;
														} else if ($scope.selectedComp.length == 2) {
															$scope.peerCompLength = 1;
														} else if ($scope.selectedComp.length == 1) {
															$scope.peerCompLength = 2;
														}
													}, 500);

										}, 300);

							});
		}
		
		$scope.resetPeerFilter= function(){
			
			$scope.industryType.value = 'sameIndustry';
			$scope.industryCategory = 'GICS';
			
			$scope.selectAllind(false);
			$scope.selectAllloc(false);
			vm.fromRatingAmount = '';
			vm.toRatingAmount = '';

			$scope.minRatingAmount = '';
			$scope.maxRatingAmount = '';

			angular.forEach($scope.ratingScaleShort, function(val, key) {
				val.chekced = false;
			});
			angular.forEach($scope.ratingScaleLong, function(val, key) {
				val.chekced = false;
			});
			
			$scope.selectAll.checked = false;
			$scope.markAll.checked = false;
			$scope.markAll1.checked = false;			
			$scope.getCompanyList();
			
		}

		$scope.isCompanyNameExists = function(compName) {
			var companyName = "";
			if ($scope.selectedComp.indexOf(compName) > -1
					&& compName != $scope.companySelected) {
				companyName = compName;
			}

			return companyName;
		}

		$scope.peerGridCompletion = function(event) {
			$scope.peerSuggestionGrid = event.target;
			$scope.peerSuggestionGrid.validateNow();
		};

		$scope.companyCodeList = [];
		$scope.companyNameList = [];
		$scope.peerCompLength = 3;
		$scope.onCheck = function(evt) {
			var grid = evt.target;
			var selectedkeys = grid.getSelectedKeys();

			var peerCompLength = $scope.peerCompLength;
			var selectedkeysLength = selectedkeys.length;
			if ($scope.peerCompLength == 2 && selectedkeys.length > 0
					&& $scope.selectedIndComp.length > 0) {
				peerCompLength = $scope.peerCompLength;

				if (!($scope.selectedIndComp.length > 0 && ($scope.selectedComp.length
						- $scope.selectedIndComp.length >= 1))) {
					++peerCompLength;
				}
			}

			if ($scope.peerCompLength == 1 && selectedkeys.length > 0
					&& $scope.selectedIndComp.length > 0) {
				peerCompLength = $scope.peerCompLength;

				if (!($scope.selectedIndComp.length > 0 && ($scope.selectedComp.length
						- $scope.selectedIndComp.length >= 1))) {
					peerCompLength = peerCompLength + 2;
					// ++peerCompLength;
				} else {
					++peerCompLength;
				}

			}

			if (selectedkeysLength > peerCompLength) {

				$scope.companyNameList = selectedkeys.slice(0,
						selectedkeys.length - 1);
				$timeout(function() {
					$scope.peerSuggestionGrid.setSelectedKeys(
							$scope.companyNameList, false);
				}, 100);

				$scope.errorMessage = "You are not allow to select more than "
						+ $scope.peerCompLength + " companies.";
				$scope.error = true;
				$timeout(function() {
					$scope.error = false;
					$scope.errorMessage = "";
				}, 2000);

			} else {
				$scope.errorMessage = "";
				$scope.error = false;
				$scope.companyNameList = selectedkeys;

			}
		}
		$scope.getData = function(item, column) {

			return ('<input type="checkbox" onClick="getPeerOutput(this)"/>');

		}
		$window.getPeerOutput = function(item) {

			if ($scope.companyNameList.length > 3 && item.checked == true) {

				item.checked = false;
				$scope.errorMessage = "You are now allow to select more than 3 companies.";
				$scope.error = true;
				$timeout(function() {

					$scope.error = false;
					$scope.errorMessage = "";

				}, 2000);

			} else {
				$scope.errorMessage = "";
				$scope.error = false;

				var data = item.parentNode.component.data;
				if ($scope.companyNameList.length == 0) {
					$scope.companyNameList.push($scope.companySelected);
					$scope.companyCodeList.push($scope.companySelectedCode);
				}

				if (item.checked) {

					$scope.companyNameList.push(data.companyName);
					$scope.companyCodeList.push(data.companyCode);
				} else {
					if ($scope.companyNameList.indexOf(data.companyName) > -1) {
						$scope.companyNameList.splice($scope.companyNameList
								.indexOf(data.companyName), 1);
						$scope.companyCodeList.splice($scope.companyCodeList
								.indexOf(data.companyCode), 1);
					}
				}

			}
		}

		$scope.getDataFromPeerSuggestion = function() {
			if ($scope.companySelected != undefined
					&& $scope.companySelectedCode != undefined) {
				$scope.companyNameList.splice(0, 0, $scope.companySelected);
				$scope.companyCodeList.push($scope.companySelectedCode);
			}
			angular.forEach($scope.selectedIndComp, function(selectedIndComp) {
				var index = $rootScope.allCompanies.indexOf(selectedIndComp);
				if (index > -1) {
					$rootScope.allCompanies.splice(index, 1);
					$rootScope.allCompaniesCode.splice(index, 1);
				}
			});
			var i = 1;
			angular.forEach($rootScope.allCompanies, function(allCompanies) {
				var index = $rootScope.allCompanies.indexOf(allCompanies);
				if (allCompanies != $scope.companySelected
						&& $rootScope.allCompaniesCode[index] != undefined
						&& $scope.companyNameList.length < 4) {
					$scope.companyNameList.splice(i, 0,
							$rootScope.allCompanies[index]);
					$scope.companyCodeList
							.push($rootScope.allCompaniesCode[index]);
					++i;
				}
			});

			angular.forEach($scope.companyNameList, function(companyName) {
				angular.forEach($scope.peerData, function(peerData) {
					if (peerData.companyName == companyName) {
						$scope.companyCodeList.push(peerData.companyCode);
					}
				});

			});

			$rootScope.allCompanies = $scope.companyNameList;

			$rootScope.allCompaniesCode = $scope.companyCodeList;

			$rootScope.industryTypes = $scope.industryType.value;

			if ($rootScope.allCompanies.length == 0) {
				$scope.error = true;
				$scope.errorMessage = "You must select atleast one company";
				$timeout(function() {

					$scope.error = false;
					$scope.errorMessage = "";

				}, 2000);
				return;
			} else {
				$uibModalInstance.dismiss('close');
			}
		}
		$scope.getCompanyList();
		$scope.getRatingScales();
		$scope.gridIndustryTree();
		$scope.setTabSetData(1);

		$scope.getIndustryType = function(industryType) {
			$scope.industryType.value = industryType;
			$scope.getCompanyList();
		}
	}
})();
